<script setup>
import { ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { useAxios } from 'dashboard/composables/useAxios';

import PageLayout from 'dashboard/components-next/captain/PageLayout.vue';
import FlowCard from 'dashboard/components-next/aivoice/FlowCard.vue';
import FlowEmptyState from '../emptyStates/FlowEmptyState.vue';

const store = useStore();
const route = useRoute();
const axios = useAxios();
const flows = ref([]);
const isFetching = ref(false);

const currentUser = computed(() => store.getters.getCurrentUser);
const accountId = computed(() => route.params.accountId);
const flowsEditorUrl = computed(() => store.state.globalConfig.flowsEditorUrl);

const fetchFlows = async () => {
  isFetching.value = true;
  try {
    const { data } = await axios.get('/api/v1/accounts/:account_id/flows');
    flows.value = data;
  } catch (error) {
    console.error('Error fetching flows:', error);
  } finally {
    isFetching.value = false;
  }
};

const openFlowsEditor = (flowId = null) => {
  // Build URL with accountId and access token
  const params = new URLSearchParams({
    accountId: accountId.value,
    token: currentUser.value.access_token,
  });

  // Add flowId if editing existing flow
  if (flowId) {
    params.set('flowId', flowId);
  }

  // Open VowChat Flows Editor with credentials
  window.open(`${flowsEditorUrl.value}?${params.toString()}`, '_blank');
};

const handleFlowClick = flowId => {
  openFlowsEditor(flowId);
};

onMounted(() => {
  fetchFlows();
});
</script>

<template>
  <PageLayout
    :header-title="$t('AI_VOICE.FLOWS_PAGE.HEADER')"
    :button-label="$t('AI_VOICE.FLOWS_PAGE.CREATE_FLOW')"
    :button-policy="['administrator']"
    :show-pagination-footer="false"
    :is-fetching="isFetching"
    :is-empty="!flows.length"
    @click="openFlowsEditor"
  >
    <template #emptyState>
      <FlowEmptyState @click="openFlowsEditor" />
    </template>

    <template #body>
      <div class="flex flex-col gap-4">
        <FlowCard
          v-for="flow in flows"
          :id="flow.id"
          :key="flow.id"
          :name="flow.name"
          :description="flow.description"
          :flow-type="flow.flow_type"
          :active="flow.active"
          :created-at="flow.created_at"
          @click="handleFlowClick"
        />
      </div>
    </template>
  </PageLayout>
</template>
